import type { Resource } from '../../';
export const product_sizeChart_category_kids: Resource = {"default":"Kids"};
